import { DealVersion } from '../../types/deal.types';
import { DealDataExport } from '../export/deal-data-export';

export function funcToDealValueProvider(
  valueGetter: (deal: DealVersion) => any
): DealDataExport.ExportDealValueProvider {
  return {
    getValue: valueGetter
  };
}

export const STRUCTURE_GRAPH_MIN_PAR = 500;
